import React, { memo } from 'react';
import classNames from 'classnames/bind';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTimer } from '../../hooks/hooks';
import styles from './circularLoader.module.scss';

const conditionalStyles = classNames.bind(styles)

export default memo(function CircularLoader(props) {
    useTimer(props.timer, props.decreaseTimer);

    return (
        <div className={styles.container}>
            {props.timer && <span className={styles.text}>{props.timer}</span>}
            <CircularProgress
                className={styles.backgroundLoader}
                size={props.size}
                thickness={2}
                value={100}
                variant="determinate"
            />
            <CircularProgress
                className={conditionalStyles({
                    loader: !props.warning,
                    warningLoader: props.warning,
                    lightLoader: props.light
                })}
                disableShrink
                size={props.size}
                thickness={2}
            />
        </div>
    );
});
